import React, { useState } from "react";
import { Button, Form, Input, message } from "antd";
import { LockOutlined, UserOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { login } from "./api";

// Константы с логином и паролем
// Теперь аутентификация через сервер

const LoginForm: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const navigate = useNavigate();

  const onFinish = async (values: { username: string; password: string }) => {
    setLoading(true);
    try {
      const data = await login(values);
      localStorage.setItem("isAuthenticated", "true");
      localStorage.setItem("username", data.username);
      localStorage.setItem("fullName", data.fullName);
      message.success("Успешный вход!");
      navigate("/");
    } catch (e) {
      const errMsg = e instanceof Error ? (e.message === 'auth failed' ? 'Неверный логин или пароль!' : e.message) : 'Ошибка авторизации';
      form.setFields([
        { name: 'username', errors: [errMsg] },
        { name: 'password', errors: [errMsg] },
      ]);
      message.error(errMsg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ maxWidth: 300, margin: "100px auto" }}>
      <h2 style={{ textAlign: "center", marginBottom: 24 }}>Вход в систему</h2>
      <Form
        name="login"
        form={form}
        initialValues={{ remember: true }}
        onFinish={onFinish}
      >
        <Form.Item
          name="username"
          rules={[{ required: true, message: "Введите логин!" }]}
        >
          <Input
            prefix={<UserOutlined />}
            placeholder="Логин"
          />
        </Form.Item>

        <Form.Item
          name="password"
          rules={[{ required: true, message: "Введите пароль!" }]}
        >
          <Input.Password
            prefix={<LockOutlined />}
            placeholder="Пароль"
          />
        </Form.Item>

        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            loading={loading}
            style={{ width: "100%" }}
          >
            Войти
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default LoginForm;